import { FilterableColumns } from "../../components/common/filter/GridDataFilter";

interface RouteImportType {
  [key: string]: {
    optionToShow: string;
    source: string;
    selectedField: string;
  };
}

export const IMPORT_RP_FILE_HEADERS = [
  "DATE",
  "ROUTE_ID",
  "BUNDLE_ID",
  "ROUTE_STATUS",
  "ARRIVAL_WINDOW",
  "PLANNED_ORDERS",
  "PROGRESS",
  "DELIVERED_ORDERS",
  "CANCELED_ORDERS",
  "RETURNED_ORDERS",
  "IN_PROCESS",
  "CURRENT_ORDERS_ON_BUNDLE",
  "EMAIL",
];

export enum DASHBORD_GRID_ACCESSOR {
  FDPNAME = "fdpName",
  TOTAL_ROUTES = "totalRoutes",
  TOTAL_PACKAGES = "totalPackages",
  ROUTE_PROGRESS = "routeProgress",
  AVERAGE_ROUTE_LENGTH = "averageRouteLength",
  AVERAGE_MILEAGE = "averageMileage",
}

export enum DASHBORD_GRID_HEADER {
  FDPNAME = "FDP Name",
  TOTAL_ROUTES = "Total Route(s)",
  TOTAL_PACKAGES = "Total Package(s)",
  ROUTE_PROGRESS = "Route Progress",
  AVERAGE_ROUTE_LENGTH = "Average Route Length",
  AVERAGE_MILEAGE = "Average Mileage",
}

export const routeProgressImportFields: RouteImportType = {
  DATE: {
    optionToShow: "DATE",
    source: "Date",
    selectedField: "NA",
  },
  ROUTE_ID: {
    optionToShow: "ROUTE_ID",
    source: "ROUTE_ID",
    selectedField: "NA",
  },
  BUNDLE_ID: {
    optionToShow: "BUNDLE_ID",
    source: "BUNDLE_ID",
    selectedField: "NA",
  },
  ROUTE_STATUS: {
    optionToShow: "ROUTE_STATUS", //Driver User Id
    source: "ROUTE_STATUS",
    selectedField: "NA",
  },
  ARRIVAL_WINDOW: {
    optionToShow: "ARRIVAL_WINDOW",
    source: "ARRIVAL_WINDOW",
    selectedField: "NA",
  },
  PLANNED_ORDERS: {
    optionToShow: "PLANNED_ORDERS",
    source: "PLANNED_ORDERS",
    selectedField: "NA",
  },
  PROGRESS: {
    optionToShow: "PROGRESS",
    source: "PROGRESS",
    selectedField: "NA",
  },
  DELIVERED_ORDERS: {
    optionToShow: "DELIVERED_ORDERS",
    source: "DELIVERED_ORDERS",
    selectedField: "NA",
  },
  CANCELED_ORDERS: {
    optionToShow: "CANCELED_ORDERS",
    source: "CANCELED_ORDERS",
    selectedField: "NA",
  },
  RETURNED_ORDERS: {
    optionToShow: "RETURNED_ORDERS",
    source: "RETURNED_ORDERS",
    selectedField: "NA",
  },
  IN_PROCESS: {
    optionToShow: "IN_PROCESS",
    source: "IN_PROCESS",
    selectedField: "NA",
  },
  CURRENT_ORDERS_ON_BUNDLE: {
    optionToShow: "CURRENT_ORDERS_ON_BUNDLE",
    source: "CURRENT_ORDERS_ON_BUNDLE",
    selectedField: "NA",
  },
  EMAIL: {
    optionToShow: "EMAIL",
    source: "EMAIL",
    selectedField: "NA",
  },
};
export const combinedFilteredData: FilterableColumns = {
  driverName: {
    displayName: "Driver Name",
    options: [],
    type: "string",
  },
  ROUTE_STATUS: {
    displayName: "Route Status",
    options: [],
    type: "string",
  },
  PLANNED_ORDERS: {
    displayName: "Total Stop(s)",
    options: [],
    type: "number",
  },
  ROUTE_ID: {
    displayName: "Route ID",
    options: [],
    type: "string",
  },
  ARRIVAL_WINDOW: {
    displayName: "Loadout Start time",
    options: [],
    type: "datetime-range",
  },
  ARRIVED_AT: {
    displayName: "Driver Arrival Time",
    options: [],
    type: "datetime-range",
  },
  STARTED_AT: {
    displayName: "Route Start Time",
    options: [],
    type: "datetime-range",
  },
  COMPLETED_AT: {
    displayName: "Route Completion",
    options: [],
    type: "datetime-range",
  },
  LAST_DELIVERY_AT: {
    displayName: "Last Delivery At",
    options: [],
    type: "datetime-range",
  },
  fileLastUpdateAt: {
    displayName: "Last Updated At",
    options: [],
    type: "datetime-range",
  },
  fdpName: {
    displayName: "FDP Name",
    options: [],
    type: "string",
  },
  totalRoutes: {
    displayName: "Total Route(s)",
    options: [],
    type: "number",
  },
  totalDeliveredPackages: {
    displayName: "Route Progress",
    options: [],
    type: "number",
  },
  totalRtsPackages: {
    displayName: "Total RTS Package(s)",
    options: [],
    type: "number",
  },
  associatedFdpName: {
    displayName: "Associated FDP Name",
    options: [],
    type: "string",
  },
  estimatedTripTime: {
    displayName: "Estimated Trip Time",
    options: [],
    type: "number",
  },
  totalTripTimes: {
    displayName: "Total Trip Time",
    options: [],
    type: "number",
  },
};

/**
 * fdpName: string;
  totalRoutes: number;
  totalPackages: number;
  totalDeliveredPackages: number;
  averageRouteLength: number;
  averageMileage: number;
 */

export const fdpRouteProgressFilter: FilterableColumns = {
  fdpName: {
    displayName: "FDP Name",
    options: [],
    type: "string",
  },
  totalRoutes: {
    displayName: "Total Route(s)",
    options: [],
    type: "number",
  },
  totalPackages: {
    displayName: "Total Package(s)",
    options: [],
    type: "number",
  },
  totalDeliveredPackages: {
    displayName: "Route Progress",
    options: [],
    type: "number",
  },
};
